let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kU163")).then(() => parcelRequire('5PwWf'));